import { render, staticRenderFns } from "./JsglList.vue?vue&type=template&id=2cb5bb81&scoped=true"
import script from "./JsglList.vue?vue&type=script&lang=js"
export * from "./JsglList.vue?vue&type=script&lang=js"
import style0 from "./JsglList.vue?vue&type=style&index=0&id=2cb5bb81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5bb81",
  null
  
)

export default component.exports